exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".l-total-cart{background-color:#46494c;margin:.5rem;color:#fff}.l-total-cart strong{font-size:16pt}.l-panier-table table{margin-bottom:0}.l-panier-table table .l-panier-table-nom-article{width:60%}.l-panier{min-height:600px}.l-table-panier-hide{display:none;transition-property:display;transition-duration:.5s;-webkit-animation-duration:.5s;animation-duration:.5s}.modal-backdrop{opacity:.3}", ""]);

// exports
